<p-confirmDialog key="NoRoleAdd" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="NoRoleAddConfirm" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Info-->
<div class="ItemBorder Grid2Col">
	<label>Users to Add Roles to:</label>
	<label class="InfoText">{{ UserCount }}</label>

	<label>District Users:</label>
	<label class="InfoText">{{ DistrictUserCount }}</label>

	<label>School Users:</label>
	<label class="InfoText">{{ SchoolUserCount }}</label>
</div>

<!--School(s)-->
<div class="ItemBorder TopMargin">
	<h4 class="ItemHeader">Select School(s) to Assign</h4>

	<div class="RadiGrid4Col">
		<input type="radio" class="RAD" name="SchoolOption" [(ngModel)]="SchoolOption" id="Home" value="Home" />
		<label for="Home">User's Home School Only</label>

		<input type="radio" class="RAD LeftMargin" name="SchoolOption" [(ngModel)]="SchoolOption" id="List" value="List" />
		<label for="List">List of Schools</label>
	</div>

	<div *ngIf="SchoolOption == 'List'" class="TableWidth">
		<p-table
			#mydt
			[value]="lstSchool"
			[loading]="IsLoading() == true"
			[paginator]="true"
			[(rows)]="schoolpagerows"
			[(first)]="schoolpagefirst"
			[showCurrentPageReport]="true"
			[resizableColumns]="false"
			sortMode="multiple"
			styleClass="p-datatable-striped"
			selectionMode="multiple"
			[(selection)]="SelectedSchools"
			dataKey="SchoolID"
			currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
			[rowsPerPageOptions]="[5, 10, 25, 50]"
		>
			<!--Headers-->
			<ng-template pTemplate="header">
				<!--Filter or Select from Dropdown-->
				<tr>
					<th class="SmallCol"></th>

					<!--SchoolName-->
					<th>
						<p-columnFilter type="text" field="SchoolName" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>

					<!--SchoolNumber-->
					<th>
						<p-columnFilter type="text" field="SchoolNumber" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>
				</tr>

				<!--Column Names-->
				<tr style="height: 4rem">
					<th class="SmallCol">
						<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
					</th>

					<th pSortableColumn="SchoolName">Name<p-sortIcon field="SchoolName"></p-sortIcon></th>
					<th pSortableColumn="SchoolNumber">Number<p-sortIcon field="SchoolNumber"></p-sortIcon></th>
				</tr>
			</ng-template>

			<!--Data-->
			<ng-template pTemplate="body" let-School>
				<tr [pSelectableRow]="School">
					<td class="SmallCol">
						<p-tableCheckbox [disabled]="IsLoading() == true" [pSelectableRow]="School" [value]="School"></p-tableCheckbox>
					</td>

					<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ School.SchoolName }}
					</td>

					<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ School.SchoolNumber }}
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
</div>

<!--Role(s)-->
<div class="ItemBorder TopMargin">
	<h4 class="ItemHeader">Select Role(s) to Assign</h4>

	<div class="TableWidth">
		<p-table
			#mydt
			[value]="lstRole"
			[loading]="IsLoading() == true"
			[paginator]="true"
			[(rows)]="rolepagerows"
			[(first)]="rolepagefirst"
			[showCurrentPageReport]="true"
			[resizableColumns]="false"
			sortMode="multiple"
			styleClass="p-datatable-striped"
			selectionMode="multiple"
			[(selection)]="SelectedRoles"
			dataKey="RoleID"
			currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
			[rowsPerPageOptions]="[5, 10, 25, 50]"
		>
			<!--Headers-->
			<ng-template pTemplate="header">
				<!--Filter or Select from Dropdown-->
				<tr>
					<th class="SmallCol"></th>

					<!--RoleDesc-->
					<th>
						<p-columnFilter type="text" field="RoleDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
					</th>
				</tr>

				<!--Column Names-->
				<tr style="height: 4rem">
					<th class="SmallCol">
						<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
					</th>

					<th pSortableColumn="RoleDesc">Role<p-sortIcon field="RoleDesc"></p-sortIcon></th>
				</tr>
			</ng-template>

			<!--Data-->
			<ng-template pTemplate="body" let-Role>
				<tr [pSelectableRow]="Role" [pTooltip]="Role.ToolTip" tooltipPosition="bottom" showDelay="500" hideDelay="125">
					<td class="SmallCol">
						<p-tableCheckbox [disabled]="IsLoading() == true" [pSelectableRow]="Role" [value]="Role"></p-tableCheckbox>
					</td>

					<td style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
						{{ Role.RoleDesc }}
					</td>
				</tr>
			</ng-template>
		</p-table>
	</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onAddRoles()">Add Roles</button>
	<button class="btn btn-warning" style="margin-left: 5px" (click)="onClose()">Cancel</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
</div>
